import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logo.jpg'


const _hoisted_1 = { class: "fixed top-0 left-0 flex justify-between w-full py-4 px-8 bg-white z-50 shadow-default" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-[145px] h-11",
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "mr-4 text-neutral-125" }

import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import BurgerMenuIcon from "../icons/BurgerMenuIcon.vue";
import CloseBurgerMenuIcon from "../icons/CloseBurgerMenuIcon.vue";
import TopMenuIcon from "./TopMenuIcon.vue";

enum TopMenuItems {
  NOTES = 'notes',
  CLEAR = 'clear',
  LOGOUT = 'logout',
  LOGS = 'logs',
}

interface PropsI {
  username: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TopMenu',
  props: {
    username: {}
  },
  emits: ["info"],
  setup(__props: any, { emit }) {

const props = __props;




const router = useRouter();

const topMenuVisible = ref<boolean>(false);
const menuRef = ref<HTMLElement | null>(null);
const iconRef = ref<HTMLElement | null>(null);

const handleClickOutside = (event: MouseEvent) => {
  if (!event.target) {
    return;
  }

  if (iconRef.value?.contains(event.target as HTMLElement)) {
    topMenuVisible.value = !topMenuVisible.value;
    return;
  }

  if (!menuRef.value?.contains(event.target as HTMLElement)) {
    topMenuVisible.value = false;
    return;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

const menuActions: Record<TopMenuItems, () => void> = {
  [TopMenuItems.LOGOUT]: () => router.push('/logout'),
  [TopMenuItems.NOTES]: () => window.open('https://support.resrequest.com/developer/resnova-back-office-setup/', '_blank'),
  [TopMenuItems.CLEAR]: () => emit("info", "Cache cleared!"),
  [TopMenuItems.LOGS]: () => router.push('/payment-gateway-logs'),
};

const handleClick = (name: TopMenuItems) => {
  const action = menuActions[name];
  if (action) {
    action();
    topMenuVisible.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, "Hi, " + _toDisplayString(props.username), 1),
      _createElementVNode("div", {
        ref_key: "iconRef",
        ref: iconRef,
        class: "flex justify-center items-center cursor-pointer"
      }, [
        _withDirectives(_createVNode(BurgerMenuIcon, null, null, 512), [
          [_vShow, !topMenuVisible.value]
        ]),
        _withDirectives(_createVNode(CloseBurgerMenuIcon, null, null, 512), [
          [_vShow, topMenuVisible.value]
        ])
      ], 512)
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "menuRef",
      ref: menuRef,
      class: "absolute top-16 right-8 flex flex-col gap-2 p-4 rounded-bl-md bg-white z-10 shadow-default"
    }, [
      _createVNode(TopMenuIcon, {
        name: TopMenuItems.NOTES,
        title: "Developer notes",
        onClick: handleClick
      }, null, 8, ["name"]),
      _createVNode(TopMenuIcon, {
        name: TopMenuItems.CLEAR,
        title: "Clear cache",
        onClick: handleClick
      }, null, 8, ["name"]),
      _createVNode(TopMenuIcon, {
        name: TopMenuItems.LOGOUT,
        title: "Logout",
        onClick: handleClick
      }, null, 8, ["name"]),
      _createVNode(TopMenuIcon, {
        name: TopMenuItems.LOGS,
        title: "Payment Gateway Logs",
        onClick: handleClick
      }, null, 8, ["name"])
    ], 512), [
      [_vShow, topMenuVisible.value]
    ])
  ]))
}
}

})